import { differenceBy } from 'lodash';

import { Action as RootAction } from '@occc-app/rootRedux/action';

import { default as types, State } from './types';

const initialState: State = {
  csvUploads: [],
};

export default function reducer(state: State = initialState, action: RootAction) {
  let csvUploads;
  let nonRequestedCsvUploads;
  switch (action.type) {
    case types.CREATE_CSV_UPLOAD_OK:
      return {
        ...state,
        csvUploads: [...state.csvUploads, action.csvUpload],
      };
    case types.REQUEST_CSV_UPLOAD_OK:
      csvUploads = state.csvUploads;

      nonRequestedCsvUploads = csvUploads.filter(
        (csvUpload) => csvUpload.id !== action.csvUpload.id,
      );

      return {
        ...state,
        csvUploads: [...nonRequestedCsvUploads, action.csvUpload],
      };
    case types.REQUEST_CSV_UPLOADS_OK:
      csvUploads = state.csvUploads;

      nonRequestedCsvUploads = differenceBy(csvUploads, action.csvUploads, 'id');
      csvUploads = [...nonRequestedCsvUploads, ...action.csvUploads];

      return {
        ...state,
        csvUploads,
      };
  }
  return state;
}
